export default __webpack_public_path__ + "static/media/estrutura6.9622f218.jpg";